// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__-hash--base64-5-","BreadTop":"BurgerIngredient__BreadTop__-hash--base64-5-","Seeds1":"BurgerIngredient__Seeds1__-hash--base64-5-","Seeds2":"BurgerIngredient__Seeds2__-hash--base64-5-","Meat":"BurgerIngredient__Meat__-hash--base64-5-","Cheese":"BurgerIngredient__Cheese__-hash--base64-5-","Salad":"BurgerIngredient__Salad__-hash--base64-5-","Bacon":"BurgerIngredient__Bacon__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredient/BurgerIngredient.css
// module id = 92
// module chunks = 0